import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// ==============================
// Responsive helpers
// ==============================
// One source of truth for breakpoint checks so components don't each re-derive
// media queries. All read MUI's default breakpoints (xs 0 / sm 600 / md 900 /
// lg 1200 / xl 1536) — the same scale `sx={{ xs, sm, md }}` uses.
//
// Bands (see docs/thuongtv/responsive-plan.md):
//   mobile  < 600px (xs)
//   tablet  600–1199px (sm, md)
//   desktop >= 1200px (lg, xl)

// This is a client-only SPA (CRA), so evaluate matchMedia synchronously on the
// first render — avoids a one-frame flash of the desktop layout on small screens.
const OPTIONS = { noSsr: true } as const;

/** Phones (portrait): below `sm` (< 600px). */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'), OPTIONS);
};

/** Tablets / small laptops: `sm`–`md` (600–1199px). */
export const useIsTablet = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between('sm', 'lg'), OPTIONS);
};

/**
 * Anything narrower than the desktop layout (< 1200px). This is the switch the
 * app shell uses to turn the sidebar into an overlay.
 */
export const useIsDownLg = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('lg'), OPTIONS);
};
